import { DatasourceTypeV2 } from "src/api/graphql/graphql"

export const supportedDataSources: DatasourceTypeV2[] = ["DATABRICKS_SQL", "POSTGRES"]
